// Central auth event logger
// Event shape: { type: 'login'|'signup'|'logout'|'error', email, success, message, meta }
// Logs only in development mode for security

export async function logAuthEvent(event) {
  const payload = {
    type: event.type,
    email: event.email || null,
    success: event.success ?? false,
    message: event.message || null,
    meta: event.meta || null,
    ts: new Date().toISOString(),
  };

  // Only log auth events in development mode
  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.info('[AUTH EVENT]', payload);
  }

  return payload; // Return for optional chaining/testing
}
